// extracted by mini-css-extract-plugin
export var askAiIcon = "_ku-9";
export var container = "_ku-0";
export var groupSeparator = "_ku-a";
export var highlight = "_ku-4";
export var resultIcon = "_ku-5";
export var resultItem = "_ku-7";
export var resultSubtitle = "_ku-3";
export var resultTitle = "_ku-2";
export var resultsList = "_ku-1";
export var searchGroup = "_ku-6";
export var selected = "_ku-8";